<template>
  <div class="auth-page d-flex justify-content-center align-items-center py-4">
    <form class="auth-card shadow-lg p-4 p-md-5" @submit.prevent="handleSubmit">
      <div class="text-center mb-4">
        <h1 class="h5 fw-semibold mb-1">Смена пароля</h1>
        <p class="text-muted small mb-0">Подтвердите смену пароля по ссылке из письма.</p>
      </div>
      <div v-if="!token" class="alert alert-warning small">
        Ссылка недействительна. Запросите смену пароля в личном кабинете снова.
      </div>
      <template v-else>
        <div class="mb-3">
          <input v-model="password" type="password" class="form-control" placeholder="Новый пароль" minlength="8" required />
        </div>
        <div class="mb-3">
          <input v-model="passwordConfirm" type="password" class="form-control" placeholder="Повтор пароля" minlength="8" required />
        </div>
        <div v-if="message" class="alert alert-success py-2 small">{{ message }}</div>
        <div v-if="errorMsg" class="alert alert-danger py-2 small">{{ errorMsg }}</div>
        <button class="btn btn-primary w-100" :disabled="loading">
          <span v-if="loading" class="spinner-border spinner-border-sm me-2" />
          Сохранить пароль
        </button>
      </template>
      <p class="text-center small text-muted mt-3 mb-0">
        <router-link to="/login">Вход</router-link>
      </p>
    </form>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import api from '@/api'
import { useAuthStore } from '@/store/pinia.js'
import { clearLocalStoragePreservingGuideSeen } from '@/utils/productGuideStorage'

const route = useRoute()
const router = useRouter()
const auth = useAuthStore()
const token = computed(() => (route.query.token || '').toString().trim())
const password = ref('')
const passwordConfirm = ref('')
const loading = ref(false)
const message = ref('')
const errorMsg = ref('')

async function handleSubmit() {
  errorMsg.value = ''
  message.value = ''
  if (password.value !== passwordConfirm.value) {
    errorMsg.value = 'Пароли не совпадают.'
    return
  }
  loading.value = true
  try {
    const { data } = await api.post('/auth/password-reset/confirm/', {
      token: token.value,
      password: password.value,
      password_confirm: passwordConfirm.value,
    })
    message.value = data?.detail || 'Пароль обновлён.'
    clearLocalStoragePreservingGuideSeen()
    auth.user = null
    auth.isAuth = false
    auth.access = null
    setTimeout(() => router.push('/login'), 2000)
  } catch (e) {
    const d = e?.response?.data
    if (typeof d === 'object' && d) {
      const parts = []
      for (const k of Object.keys(d)) {
        const v = d[k]
        if (Array.isArray(v)) parts.push(...v.map(String))
        else if (typeof v === 'string') parts.push(v)
      }
      errorMsg.value = parts.join(' ') || 'Ссылка недействительна или истекла.'
    } else {
      errorMsg.value = 'Ссылка недействительна или истекла.'
    }
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.auth-page {
  min-height: 100vh;
  background: #f7f8fa;
}
.auth-card {
  width: min(520px, 100%);
  background: #fff;
  border-radius: 16px;
}
</style>
